<template>
    <IndexPage />
</template>

<script>
import IndexPage from './components/IndexPage.vue'

export default {
  components: {
    IndexPage
  }
}

</script>
